import { inject, type InjectionKey } from "vue";

export type GlobalErrorHandler = (error: unknown) => void;
export type GlobalMessageHandler = (title: string, description: string) => void;

/** Keys App.vue provides its global handlers under; typed so provider and consumers can't drift. */
export const globalErrorHandlerKey: InjectionKey<GlobalErrorHandler> =
  Symbol("globalErrorHandler");
export const globalWarningHandlerKey: InjectionKey<GlobalMessageHandler> =
  Symbol("globalWarningHandler");
export const globalSuccessHandlerKey: InjectionKey<GlobalMessageHandler> =
  Symbol("globalSuccessHandler");

/**
 * Injects the global error, warning and success handlers provided by App.vue.
 * Must be called during component setup (or from a composable called there).
 */
export const useGlobalHandlers = () => ({
  globalErrorHandler: inject(globalErrorHandlerKey)!,
  globalWarningHandler: inject(globalWarningHandlerKey)!,
  globalSuccessHandler: inject(globalSuccessHandlerKey)!,
});
